import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Book(props: StickerArtProps) {
  return (
    <StickerFrame background="#b45309" {...props}>
      <path d="M32 20 C26 15 18 15 11 18 V47 C18 44 26 44 32 49 Z" fill="#ffffff" />
      <path d="M32 20 C38 15 46 15 53 18 V47 C46 44 38 44 32 49 Z" fill="#ffffff" />
      <path d="M32 20 V49" stroke="#1f2937" strokeWidth="2.5" />
      <path
        d="M16 25 Q22 23 27 25 M16 31 Q22 29 27 31 M16 37 Q22 35 27 37 M37 25 Q42 23 48 25 M37 31 Q42 29 48 31 M37 37 Q42 35 48 37"
        fill="none"
        stroke="#b45309"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </StickerFrame>
  );
}
